const middleware = {}

middleware['route-guard'] = require('../src/middleware/route-guard.js')
middleware['route-guard'] = middleware['route-guard'].default || middleware['route-guard']

export default middleware
